import type { ReactElement, ReactNode } from 'react'

import './styles.scss'

interface Props {
  circleText: string
  content: ReactNode
}

const Step = ({ circleText, content }: Props): ReactElement => {
  return (
    <div className="step">
      <div className="step__circle-container">
        <div className="outer-circle">
          <div className="circle">{circleText}</div>
        </div>
      </div>
      <div className="step__content">{content}</div>
    </div>
  )
}

export default Step
